import { BrandLoader } from "@/components/brand";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { casePath } from "../features/caseIde/routes";
import { CLIENT_PORTAL_PATH } from "../features/clientPortal/routes";
import { PORTAL_PATH } from "../features/companyPortal/routes";
import { HOME_PATH } from "../features/dashboard/routes";
import {
  ONBOARDING_PATH,
  shouldRedirectToOnboarding
} from "../features/onboarding/routes";
import { lawyerSelectors } from "../redux/lawyer/selectors";

export const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const onboardingStatus = useSelector(lawyerSelectors.selectOnboardingStatus);
  useEffect(() => {
    const loginType = localStorage.getItem("loginType");
    const userId = localStorage.getItem("userId");

    // If the user is not logged in
    if (!loginType) {
      if (location.pathname !== "/login") {
        // Redirect to the login page
        navigate("/login", { replace: true });
      }
      return;
    }

    // Handle logged-in users based on login type
    switch (loginType) {
      case "lawyer": {
        // A member who has never started onboarding begins there.
        const landing = shouldRedirectToOnboarding(onboardingStatus)
          ? ONBOARDING_PATH
          : HOME_PATH;
        if (location.pathname !== landing) {
          navigate(landing, { replace: true });
        }
        break;
      }
      case "client":
        if (location.pathname !== CLIENT_PORTAL_PATH) {
          navigate(CLIENT_PORTAL_PATH, { replace: true });
        }
        break;
      case "company":
        navigate(PORTAL_PATH, { replace: true });
        break;
      case "individual":
        if (userId) {
          const individualPath = casePath({ individualId: userId });
          if (location.pathname !== individualPath) {
            navigate(individualPath, { replace: true });
          }
        } else {
          Sentry.captureException(new Error("Missing individual user id"));
          navigate("/login", { replace: true });
        }
        break;
      default:
        navigate("/login", { replace: true });
        break;
    }
  }, [navigate, location.pathname, onboardingStatus]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <BrandLoader size="xl" />
    </div>
  );
};
